import {
  PaperProps,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  Grid,
} from "@mui/material";
import Draggable from "react-draggable";
import MDBox from "../../../../Components/MDBox";
import MDTableCell from "../../../../Components/MDTable/MDTableCell";
import MDTableRow from "../../../../Components/MDTable/MDTableRow";
import { SubscriberDto } from "../../../../Types/Api/DTO/SubscriberDto";
import InfoIcon from "@mui/icons-material/Info";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import { v4 as uuid } from "uuid";
import MDButton from "../../../../Components/MDButton";
import MDTypography from "../../../../Components/MDTypography";
import { useState } from "react";
import AddChildSubscriber from "./AddChildSubscriber";
import AppLoading from "../../../../Components/MDLoading";

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
interface ISubrows {
  Subscribe: SubscriberDto;
  setDetailModal: any;
  setCounter: any;
}

export default function SubRows(props: ISubrows) {
  const [AEDialog, setAEDialog] = useState<any>({
    open: false,
    subId: 0,
    subscribeRows: [],
    SubExpireDate: "",
    parentId: 0,
  });
  const [loading, setLoading] = useState(false);
  if (!props.Subscribe) {
    return null;
  }
  return (
    <MDBox>
      <Button variant="outlined">Open draggable dialog</Button>
      <Dialog
        open={true}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        onClose={(r) => {
          props.setDetailModal({ show: false, rowId: 0, subscribeRows: [] });
        }}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          <Grid container justifyContent={"space-between"}>
            <Grid item>
              <MDTypography color="dark">قبض های صادر شده</MDTypography>
            </Grid>
            <Grid item>
              <MDButton
                variant="outlined"
                color="dark"
                onClick={(e: HTMLButtonElement) => {
                  setAEDialog({
                    open: true,
                    subId: 0,
                    subscribeRows: props.Subscribe.subscribeRows,
                    SubExpireDate: "",
                    parentId: props.Subscribe.id,
                  });
                }}
              >
                افزودن
              </MDButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container justifyContent={"flex-end"}>
            <IconButton onClick={() => window.open(`/webroutes/AllGhabzs/${props.Subscribe.id}`, "_blank")}>
              <PrintIcon />
            </IconButton>
          </Grid>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    شماره اشتراک
                  </MDTableCell>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    مبلغ کل
                  </MDTableCell>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    نوع قالب قبض
                  </MDTableCell>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    تاریخ انقضا
                  </MDTableCell>
                  <MDTableCell align={"center"} style={{ minWidth: 170 }}>
                    عملیات
                  </MDTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <MDTableRow hover role="checkbox" tabIndex={-1}>
                  <MDTableCell align={"center"}>{props.Subscribe.subscriber}</MDTableCell>
                  <MDTableCell align={"center"}>{props.Subscribe.totalAmount}</MDTableCell>
                  <MDTableCell align={"center"}>{props.Subscribe.ghabzAvarezName}</MDTableCell>
                  {(() => {
                    console.log(props.Subscribe)
                  })()}
                  <MDTableCell align={"center"}>{props.Subscribe.expireDate}</MDTableCell>
                  <MDTableCell align={"center"}>
                    <Tooltip title={"جزئیات"}>
                      <InfoIcon
                        onClick={() => window.open(`/Subscribers/detail?Id=${props.Subscribe.id}`, "_blank")}
                        color="info"
                        fontSize="medium"
                        sx={{ cursor: "pointer", mx: 2 }}
                      />
                    </Tooltip>
                    <Tooltip title={"ویرایش"}>
                      <EditIcon
                        onClick={() =>
                          setAEDialog({
                            open: true,
                            subId: props.Subscribe.id,
                            subscribeRows: props.Subscribe.subscribeRows,
                            SubExpireDate: props.Subscribe.expireDate,
                            parentId: 0,
                          })
                        }
                        color="info"
                        fontSize="medium"
                        sx={{ cursor: "pointer", mx: 2 }}
                      />
                    </Tooltip>
                    <PrintIcon
                      onClick={() => window.open(`/webroutes/GhabzGet/${props.Subscribe.id}`, "_blank")}
                      color="secondary"
                      fontSize="medium"
                      sx={{ cursor: "pointer", mx: 2 }}
                    />
                  </MDTableCell>
                </MDTableRow>
                {props.Subscribe.children.map((r) => {
                  return (
                    <MDTableRow hover role="checkbox" tabIndex={-1} key={uuid()}>
                      <MDTableCell align={"center"}>{r.subscriber}</MDTableCell>
                      <MDTableCell align={"center"}>{r.totalAmount}</MDTableCell>
                      <MDTableCell align={"center"}>{r.ghabzAvarezName}</MDTableCell>

                      <MDTableCell align={"center"}>{r.expireDate}</MDTableCell>
                      <MDTableCell align={"center"}>
                        <Tooltip title={"جزئیات"}>
                          <InfoIcon
                            onClick={() => window.open(`/Subscribers/detail?Id=${r.id}`, "_blank")}
                            color="info"
                            fontSize="medium"
                            sx={{ cursor: "pointer", mx: 2 }}
                          />
                        </Tooltip>
                        <Tooltip title={"ویرایش"}>
                          <EditIcon
                            onClick={() => {
                              setAEDialog({
                                open: true,
                                subId: r.id,
                                subscribeRows: r.subscribeRows,
                                SubExpireDate: r.expireDate,
                                parentId: props.Subscribe.id,
                              });
                            }}
                            color="info"
                            fontSize="medium"
                            sx={{ cursor: "pointer", mx: 2 }}
                          />
                        </Tooltip>
                        <PrintIcon
                          onClick={() => window.open(`/webroutes/GhabzGet/${r.id}`, "_blank")}
                          color="secondary"
                          fontSize="medium"
                          sx={{ cursor: "pointer", mx: 2 }}
                        />
                      </MDTableCell>
                    </MDTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="dark"
            variant="text"
            onClick={() => {
              props.setDetailModal({ show: false, rowId: 0 });
            }}
          >
            بستن
          </MDButton>
        </DialogActions>
      </Dialog>
      {AEDialog.open && (
        <AddChildSubscriber
          open={AEDialog.open}
          setClose={() => setAEDialog((r: any) => ({ ...r, open: false }))}
          onDone={() => props.setCounter((c: any) => c + 1)}
          loading={loading}
          setLoading={setLoading}
          subscribe={props.Subscribe}
          subId={AEDialog.subId}
          subscribeRows={AEDialog.subscribeRows}
          subExpireDate={AEDialog.SubExpireDate}
          parentId={AEDialog.parentId}
        />
      )}
      <AppLoading show={loading} />
    </MDBox>
  );
}
